const PROTOCOLS = [ 'HTTP', 'SMTP', 'FTP', 'IMAP', 'POP3' ]

export default {
  protocols: PROTOCOLS
}



// WEBPACK FOOTER //
// ./src/lib/stats.js